import { InfoWithLabel } from "@/core/components/info-with-label";
import { Skeleton } from "@/core/components/ui/skeleton";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import { useGetActivityReferral } from "@/activity-feed/query";
import { formatPhoneNumber } from "@/core/utils/phone";
import { getCustomerNameOrPhone } from "@/customer/utils";
import { ISpiff, ReferralTrigger } from "@/spiffs/spiffs.d";

interface NewReferralTriggerDetailsProps {
  spiff: ISpiff;
}

export const NewReferralTriggerDetails = ({
  spiff,
}: NewReferralTriggerDetailsProps) => {
  const referralTrigger = spiff.trigger as ReferralTrigger;
  const { data: referral, isLoading } = useGetActivityReferral(
    referralTrigger.id,
  );

  if (isLoading) {
    return (
      <Stack gap="sm" fullWidth>
        <InfoWithLabel label="Customer">
          <Skeleton className="h-5 w-48" />
        </InfoWithLabel>
        <Stack direction="row" gap="none" fullWidth>
          <InfoWithLabel label="Phone">
            <Skeleton className="h-5 w-40" />
          </InfoWithLabel>
          <InfoWithLabel label="Service">
            <Skeleton className="h-5 w-32" />
          </InfoWithLabel>
        </Stack>
        <Stack direction="row" gap="none" fullWidth>
          <InfoWithLabel label="Advocate">
            <Skeleton className="h-5 w-40" />
          </InfoWithLabel>
          <InfoWithLabel label="Advocate Phone">
            <Skeleton className="h-5 w-40" />
          </InfoWithLabel>
        </Stack>
      </Stack>
    );
  }

  if (!referral) {
    return (
      <InfoWithLabel label="Referral">
        <Typography variant="bodyW1" textColor="secondary">
          Referral information unavailable
        </Typography>
      </InfoWithLabel>
    );
  }

  return (
    <Stack gap="sm" fullWidth>
      <InfoWithLabel label="Customer">
        {getCustomerNameOrPhone(referral.potential_customer)}
      </InfoWithLabel>
      <Stack direction="row" gap="none" fullWidth>
        <InfoWithLabel label="Phone">
          {formatPhoneNumber(referral.potential_customer.phone_number)}
        </InfoWithLabel>
        <InfoWithLabel label="Service">{referral.service_needed}</InfoWithLabel>
      </Stack>
      <Stack direction="row" gap="none" fullWidth>
        <InfoWithLabel label="Advocate">
          {getCustomerNameOrPhone(referral.advocate)}
        </InfoWithLabel>
        <InfoWithLabel label="Advocate Phone">
          {formatPhoneNumber(referral.advocate.phone_number)}
        </InfoWithLabel>
      </Stack>
    </Stack>
  );
};
